class FrameFinderDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.maybeClose());
    // this.querySelector('#FrameFinderDrawer-Overlay').addEventListener('click', this.close.bind(this));

    document.addEventListener('framefinder:select', (e) => {
      const { product, displayValue } = e.detail;
      this.selected_frame_handle = product.handle;
      this.selected_frame_base_model = displayValue;
      this.selected_frame_model = displayValue; 
      this.next_button.dataset.selected_frame_handle = product.handle;
      this.frame_names.forEach(el => el.textContent = displayValue)
      this.next_button.removeAttribute('disabled')
    })
    document.addEventListener('click', (e) => {
      if (!e.target.closest('.frame-search-wrap-3')) {
        const results = this.step_3_dynamic?.querySelector('.ff-legacy-search-results');
        if (results) {
          results.setAttribute('hidden', '');
          results.style.display = '';
        }
      }
    })
    this.addEventListener('input', (evt) => {
      if (evt.target.closest('.frame-search-wrap-3 input[type="search"]')) {
        this.handleLegacySearch(evt.target);
      }
    })

    this.addEventListener('click', (evt) => {
      if (evt.target.closest('.frame-search-wrap-3 .search__button')) {
        evt.preventDefault();
        const input = evt.target.closest('.frame-search-wrap-3').querySelector('input[type="search"]');
        if (input) this.handleLegacySearch(input);
      }
    })

    this.setOpenerAccessibility();

    // elements
    this.drawer_inner = this.querySelector('.drawer__inner')
    this.main_title = this.querySelector('.drawer__header h2.drawer__heading')
    this.close_button = this.querySelector('.drawer__close')
    this.progress_bar = this.querySelector('.frame-finder-progress')
    this.progress_bar_step_2 = this.querySelector('.pb-ff-step-2')
    this.progress_bar_step_3 = this.querySelector('.pb-ff-step-3')
    this.progress_bar_step_4 = this.querySelector('.pb-ff-step-4')
    this.main = this.querySelector('.frame-finder-main')
    this.footer = this.querySelector('.drawer__footer')
    this.help_wrap = this.querySelector('.quiz-help')
    this.help_text_brand = this.querySelector('.help-text-brand')
    this.help_text_frames = this.querySelector('.help-text-frames')
    this.quit_wrap = this.querySelector('.quit-the-quiz')
    this.step_1 = this.querySelector('.ff-step-1')
    this.step_2 = this.querySelector('.ff-step-2')
    this.step_3 = this.querySelector('.ff-step-3')
    this.step_3_visited = false;
    this.step_4 = this.querySelector('.ff-step-4')
    this.popular_brands = this.querySelectorAll('[name="ff_popular_brands"]')
    this.all_brands = this.querySelectorAll('[name="ff_all_brands"]')
    this.all_brands_text = this.querySelector('[data-current_brand]')
    this.brand_names = this.querySelectorAll('.brand-name')
    this.frame_names = this.querySelectorAll('.ff-frame-model')
    this.selected_frame_model = '';
    this.collection_total = this.querySelector('.collection-total-num')

    // buttons
    this.back_button = this.querySelector('.ff-button-back')
    this.back_text = this.querySelector('.back-text')
    this.next_button = this.querySelector('.ff-button-next')
    this.help_button = this.querySelectorAll('.show-frame-finder-help')
    this.quiz_resume = this.querySelector('[data-button_resume]')
    this.quiz_quit = this.querySelector('[data-button_quit]')

    this.step_2_dynamic = this.querySelector('.ff-step-2-dynamic')
    this.step_3_dynamic = this.querySelector('.ff-step-3-dynamic')
    this.step_3b_dynamic = this.querySelector('.ff-step-3b-dynamic')
    this.step_4_dynamic = this.querySelector('.ff-step-4-dynamic')
    this.selected_legacy_sku = '';

    //this.handleBrands = this.handleBrands.bind(this);
    //this.updateBrandsTitle = this.updateBrandsTitle.bind(this);
    this.addEventListener('change', (evt) => {
      if ( evt.target.closest('[name="ff_popular_brands"]') ) {
        const brand_input = evt.target
        this.handleBrands(brand_input);
        // clear any checked all_brands selection and reset title
        // this.all_brands.forEach(input => input.checked = false);
        this.querySelectorAll('[name="ff_all_brands"]').forEach(input => input.checked = false);
        this.all_brands_text.textContent = this.all_brands_text.dataset.original_text;
        
        // auto-advance to step 2
        setTimeout(() => this.goToStep2(), 300);
      }
      if ( evt.target.closest('[name="ff_all_brands"]') ) {
        const brand_input = evt.target
        this.handleBrands(brand_input);
        this.updateBrandsTitle(brand_input);
        brand_input.closest('details').removeAttribute('open'); 
        // clear any checked popular brand
        this.popular_brands.forEach(input => input.checked = false);
      }
      if (evt.target.closest('[name="ff_models"]')) {
        const model_input = evt.target;
        this.selected_model_handle = model_input.value;
        this.selected_frame_model = model_input.dataset.displayName || '';
        
        this.fetchStep3b(model_input.value);
      }
    })
    this.addEventListener('click', (evt) => {
      if (evt.target.closest('.ff-reset')) {
        this.resetQuiz();
      }
      if (evt.target.closest('.ff-legacy-result')) {
        this.legacy_selecting = true;
        evt.preventDefault();
        const btn = evt.target.closest('.ff-legacy-result');
        const sku = btn.dataset.sku;
        const alert_wrap = btn.closest('.rare-shades-alert');
        const input = alert_wrap.querySelector('.frame-search-wrap-3 input[type="search"]');
        
        // populate input
        input.value = sku;
        
        // hide results
        const results = btn.closest('.ff-legacy-search-results');
        results.setAttribute('hidden', '');
        results.style.display = '';

        // store the sku for use in step 4
        this.selected_legacy_sku = sku;

        // fill in and show confirmation message
        const confirmation = this.step_3b_dynamic.querySelector('.confirm-legacy-sku');
        if (confirmation) {
          confirmation.querySelector('.brand-name').textContent = this.next_button.dataset.selected_brand;
          const checked_radio = this.step_3_dynamic.querySelector('[name="ff_models"]:checked');
          const frame_model = checked_radio?.dataset.displayName || this.selected_frame_model;
          confirmation.querySelector('.ff-frame-model').textContent = frame_model;
          confirmation.removeAttribute('hidden');
        }

        // dispatch event
        this.dispatchEvent(new CustomEvent('framefinder:legacy-sku-select', {
          bubbles: true,
          detail: {
            sku,
            brand: this.next_button.dataset.selected_brand,
            frame: this.selected_frame_model || ''
          }
        }));
        // 200ms guard against the document-click handler swallowing the legacy-result click
        setTimeout(() => this.legacy_selecting = false, 200);
      }
    })

    this.close_button.addEventListener('click', () => this.maybeClose())
    this.back_button.addEventListener('click', () => this.goBack())
    this.help_button.forEach(el => el.addEventListener('click', () => this.showHelp()))
    //this.help_button.addEventListener('click', () => this.showHelp())
    this.hideHelp = this.hideHelp.bind(this);
    this.resetQuiz = this.resetQuiz.bind(this);
    this.quiz_resume.addEventListener('click', () => this.resumeQuiz())
    this.quiz_quit.addEventListener('click', () => {
      this.close();
      this.resetQuiz();
    })


    this.next_button.addEventListener('click', () => this.handleNext())

    const brandDetails = this.querySelector('#ff-facets-filter-brand details');
    brandDetails.addEventListener('toggle', () => {
      if (brandDetails.open) {
        this.footer.style.height = '0';
        this.footer.style.overflow = 'hidden';
        this.footer.style.padding = '0';
        this.main.classList.add('desktop-overflow')
      } else {
        this.footer.style.height = '';
        this.footer.style.overflow = '';
        this.footer.style.padding = '';
        this.main.classList.remove('desktop-overflow')
      }
    });

    window.addEventListener('pagehide', () => {
      this.close();
      this.resetQuiz();
    });

    window.addEventListener('pageshow', () => {
      this.close();
      this.resetQuiz();
    })

    this.fetchBrands();

  }

  handleBrands(brand_input) {
    this.next_button.dataset.selected_brand = brand_input.dataset.brand;
    this.next_button.dataset.selected_brand_handle = brand_input.value;
    this.next_button.removeAttribute('disabled')
    this.fetchStep2(brand_input.value);
  }

  updateBrandsTitle(brand_input) {
    this.all_brands_text.textContent = brand_input.dataset.brand;
  }

  fetchStep2(collectionHandle) {
    const sectionId = 'frame-finder-step-2'; // whatever your section id is
    const url = `/collections/${collectionHandle}?section_id=${sectionId}`;

    fetch(url)
      .then(response => response.text())
      .then(responseText => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const total = html.querySelector('[data-collection_total]')
        const sectionContent = html.querySelector('.shopify-section');
        if (sectionContent) {
          this.step_2_dynamic.innerHTML = sectionContent.innerHTML;
        }

        if (total) this.collection_total.textContent = total.dataset.collection_total;
      })
      .catch(err => console.error('Frame finder fetch error:', err));
  }


  fetchStep3(productHandle) {
    const sectionId = 'frame-finder-step-3';
    const url = `/products/${productHandle}?section_id=${sectionId}`;

    fetch(url)
      .then(response => response.text())
      .then(responseText => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const total = html.querySelector('[data-collection_total]')
        const sectionContent = html.querySelector('.shopify-section');
        if (sectionContent) {
          this.step_3_dynamic.innerHTML = sectionContent.innerHTML;
          
          // reinitialize legacy search if legacy skus present
          const legacy_input = this.step_3_dynamic.querySelector('.frame-search-wrap-3 input[type="search"]');
          if (legacy_input) {
            legacy_input.value = '';
            const results = this.step_3_dynamic.querySelector('.ff-legacy-search-results');
            if (results) {
              results.setAttribute('hidden', '');
              results.style.display = '';
            }
          }

          // reset legacy sku selection state
          this.selected_legacy_sku = '';
          const confirmation = this.step_3b_dynamic.querySelector('.confirm-legacy-sku');
          if (confirmation) confirmation.setAttribute('hidden', '');
        }

        if (total) this.collection_total.textContent = total.dataset.collection_total;
      })
      .catch(err => console.error('Frame finder fetch error:', err));
  }

  fetchStep3b(productHandle) {
    const sectionId = 'frame-finder-step-3b';
    const url = `/products/${productHandle}?section_id=${sectionId}`;

    fetch(url)
      .then(response => response.text())
      .then(responseText => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const sectionContent = html.querySelector('.shopify-section');
        if (sectionContent) {
          this.step_3b_dynamic.innerHTML = sectionContent.innerHTML;

          // query fresh every time instead of using cached this.frame_names
          this.step_3b_dynamic.querySelectorAll('.ff-frame-model').forEach(el => {
            el.textContent = this.selected_frame_model;
          })
          this.step_3b_dynamic.querySelectorAll('.brand-name').forEach(el => {
            el.textContent = this.next_button.dataset.selected_brand;
          })
          this.step_3_dynamic.querySelectorAll('.ff-frame-model').forEach(el => {
            el.textContent = this.selected_frame_model;
          })
          this.step_3_dynamic.querySelectorAll('.brand-name').forEach(el => {
            el.textContent = this.next_button.dataset.selected_brand;
          })

          // reset legacy sku selection state
          this.selected_legacy_sku = '';
          const confirmation = this.step_3b_dynamic.querySelector('.confirm-legacy-sku');
          if (confirmation) confirmation.setAttribute('hidden', '');

        }
      })
      .catch(err => console.error('Frame finder step 3b fetch error:', err));
  }

  fetchStep4(productHandle) {
    const sectionId = 'frame-finder-step-4';
    let url = `/products/${productHandle}?section_id=${sectionId}`;
    if (this.selected_legacy_sku) {
      url += `&sku=${encodeURIComponent(this.selected_legacy_sku)}`;
    }

    fetch(url)
      .then(response => response.text())
      .then(responseText => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const sectionContent = html.querySelector('.shopify-section');
        if (sectionContent) {
          this.step_4_dynamic.innerHTML = sectionContent.innerHTML;

          // populate legacy sku values if present
          if (this.selected_legacy_sku) {
            this.step_4_dynamic.querySelectorAll('.legacy-sku-value').forEach(el => {
              el.textContent = this.selected_legacy_sku;
              el.closest('[hidden]')?.removeAttribute('hidden');
            })
          }
        }
      })
      .catch(err => console.error('Frame finder step 4 fetch error:', err));
  }

  handleNext() {
    if (this.is_transitioning) return;
    this.is_transitioning = true;
    setTimeout(() => this.is_transitioning = false, 400);

    if (this.next_button.dataset.current_step === '1') {
      if (this.next_button.dataset.selected_brand_handle === 'Any Brand') {
        this.showHelp();
      } else {
        this.goToStep2();
      }
    } else if (this.next_button.dataset.current_step === '2') {
      const handle = this.next_button.dataset.selected_frame_handle;
      this.checkProductMetafields(handle);
      //this.goToStep3(handle);
    } else if (this.next_button.dataset.current_step === '3') {
      const checked = this.step_3_dynamic.querySelector('[name="ff_models"]:checked');
      // products with no product_group metafield render no ff_models radios at all,
      // so fall back to the handle captured when the product was selected in step 2
      const handle = checked ? checked.value : (this.selected_model_handle || this.next_button.dataset.selected_frame_handle);
      this.goToStep4(handle);
    }
  }

  handleLegacySearch(input) {
    if (this.legacy_selecting) return;
    const alert_wrap = input.closest('.rare-shades-alert');
    if (!alert_wrap) return;

    const skus_el = alert_wrap.querySelector('[data-legacy_skus]');
    if (!skus_el) return;

    const checked_radio = this.step_3_dynamic.querySelector('[name="ff_models"]:checked');
    const model_name = checked_radio?.dataset.displayName || this.selected_frame_model;
    const model_text = checked_radio?.dataset.model_text || 'model number';

    const skus = skus_el.dataset.legacy_skus.split(',').map(s => s.trim()).filter(Boolean);
    const query = input.value.trim().toLowerCase();

    // find or create results container
    let results_container = alert_wrap.querySelector('.ff-legacy-search-results');
    if (!results_container) {
      results_container = document.createElement('div');
      results_container.classList.add('ff-legacy-search-results', 'predictive-search', 'ff-search-results');
      results_container.setAttribute('role', 'listbox');
      input.closest('.field').after(results_container);
    }

    if (!query) {
      results_container.innerHTML = '';
      results_container.setAttribute('hidden', '');
      return;
    }

    const matches = skus.filter(sku => sku.toLowerCase().includes(query));

    if (matches.length === 0) {
      const help_content = this.help_wrap.querySelector('.help-options-wrap');
      const search_help_text = input.closest('.frame-search-wrap-3')?.dataset.search_help_text;
      if (help_content) {
        results_container.removeAttribute('hidden');
        results_container.style.display = 'block';
        results_container.innerHTML = `
          <div class="search-help-wrapper">
            ${search_help_text ? `<p class="search-help-text">${search_help_text}</p>` : ''}
            ${help_content.outerHTML}
          </div>
        `;
      } else {
        results_container.setAttribute('hidden', '');
        results_container.style.display = '';
      }
      return;
    }

    results_container.removeAttribute('hidden');
    results_container.style.display = 'block';

    results_container.innerHTML = `
      <ul class="ff-search-results__list" role="presentation">
        ${matches.map((sku, i) => `
          <li class="ff-search-results__item" role="presentation">
            <button type="button" class="ff-search-results__button predictive-search__item ff-legacy-result" role="option" aria-selected="false" data-sku="${sku}">
              <span class="legacy-result-frame-model">${model_name}</span>
              <span class="legacy-result-model-text">${model_text}</span>
              <span class="legacy-result-sku">${sku.replace(new RegExp(query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'gi'), match => `<mark>${match}</mark>`)}</span>
            </button>
          </li>
        `).join('')}
      </ul>
    `;
  }

  checkProductMetafields(productHandle) {
    fetch(`/products/${productHandle}?section_id=frame-finder-metafield-check`)
      .then(res => res.text())
      .then(responseText => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const el = html.querySelector('[data-legacy]');
        if (!el) {
          console.error('frame-finder-metafield-check: [data-legacy] element not found for', productHandle);
          return;
        }
        const has_legacy = el.dataset.legacy !== 'null' && el.dataset.legacy !== '';
        const has_group = el.dataset.group !== 'null' && el.dataset.group !== '';

        if (has_legacy || has_group) {
          this.goToStep3(productHandle);
        } else {
          this.progress_bar_step_3.classList.add('done')
          this.progress_bar_step_4.classList.add('done')
          this.goToStep2ToStep4(productHandle);
        }
      })
      .catch(err => console.error('Error fetching product metafields:', err));
  }

  goToStep2ToStep4(productHandle) {
    this.step_3_visited = false;
    this.drawer_inner.style.overflow = 'hidden'
    this.step_2.classList.add('off-left')
    this.next_button.dataset.current_step = '4'
    this.step_4.classList.remove('quiz-hide')
    this.footer.setAttribute('hidden', '')
    this.footer.style.display = 'none'

    this.fetchStep4(productHandle);

    setTimeout(() => {
      this.step_2.classList.add('quiz-hide')
      this.step_4.classList.remove('off-right')
      this.next_button.setAttribute('disabled', true)
      this.updateInertStates()
    }, 100);
  }

  goToStep4ToStep2() {
    this.step_4.classList.remove('done')
    this.step_2.classList.remove('off-left')
    this.next_button.dataset.current_step = '2'
    this.step_4.classList.add('off-right')
    this.progress_bar_step_3.classList.remove('done')
    this.progress_bar_step_4.classList.remove('done')
    this.footer.removeAttribute('hidden')
    this.footer.style.display = ''

    setTimeout(() => {
      this.step_4.classList.add('quiz-hide')
      this.step_2.classList.remove('quiz-hide')
      this.checkStep2NextButton();

      const total_el = this.step_2_dynamic.querySelector('[data-collection_total]');
      if (total_el) this.collection_total.textContent = total_el.dataset.collection_total;
      this.updateInertStates()
    }, 100);
  }

  goBack() {
    const step = this.next_button.dataset.current_step;
    if (this.back_button.classList.contains('is-help')) {
      this.hideHelp();
      return;
    }
    if (step === '2') { this.goToStep1(); return; }
    if (step === '3') { this.goToStep2FromStep3(); return; }
    if (step === '4') {
      if (this.step_3_visited) {
        this.goToStep3FromStep4();
      } else {
        this.goToStep4ToStep2();
      }
      return;
    }
  }



  goToStep1() {
    this.step_2.classList.remove('done')
    this.drawer_inner.style.overflow = 'visible'
    this.step_1.classList.remove('off-left')
    this.next_button.dataset.current_step = '1'
    this.step_2.classList.add('off-right')
    this.progress_bar_step_2.classList.remove('done')
    this.back_button.style.display = 'none'

    setTimeout(() => {
      this.step_2.classList.add('quiz-hide')
      this.step_1.classList.remove('quiz-hide')
      this.step_1.classList.remove('off-left')
      this.next_button.removeAttribute('disabled')
      this.help_text_brand.removeAttribute('hidden')
      this.help_text_frames.setAttribute('hidden', '')
      this.updateInertStates()
    }, 100);
    
  }

  goToStep2() {
    this.drawer_inner.style.overflow = 'hidden'
    this.step_1.classList.add('off-left')
    this.next_button.dataset.current_step = '2'
    /* const brand_name_el = this.step_2.querySelector('.brand-name')
    brand_name_el.textContent = this.next_button.dataset.selected_brand; */
    this.brand_names.forEach(el => el.textContent = this.next_button.dataset.selected_brand)
    this.step_2.classList.remove('quiz-hide');
    this.progress_bar_step_2.classList.add('done')
    this.back_button.style.display = 'flex'

    setTimeout(() => {
      this.step_1.classList.add('quiz-hide')
      this.step_2.classList.remove('off-right')
      this.next_button.setAttribute('disabled', true)
      // this.next_button.setAttribute('disabled', true)
      this.help_text_brand.setAttribute('hidden', '')
      this.help_text_frames.removeAttribute('hidden')
      this.updateInertStates()
      this.retrapFocus()
    }, 100);
    
  }

  goToStep3(productHandle) {
    this.step_3_visited = true;
    this.selected_frame_model = this.selected_frame_base_model;
    // clear out any model radio selected on a previously-viewed product so it can't
    // leak through as a stale fallback handle if this product has no ff_models radios
    this.selected_model_handle = '';

    this.drawer_inner.style.overflow = 'hidden'
    this.step_2.classList.add('off-left')
    this.next_button.dataset.current_step = '3'
    this.step_3.classList.remove('quiz-hide')
    this.progress_bar_step_3.classList.add('done')

    this.fetchStep3(productHandle);
    this.fetchStep3b(productHandle);

    setTimeout(() => {
      this.step_2.classList.add('quiz-hide')
      this.step_3.classList.remove('off-right')
      this.next_button.removeAttribute('disabled')
      this.updateInertStates()
    }, 100);
  }

  goToStep4(productHandle) {
    this.drawer_inner.style.overflow = 'hidden'
    this.step_3.classList.add('off-left')
    this.next_button.dataset.current_step = '4'
    this.step_4.classList.remove('quiz-hide')
    this.progress_bar_step_4.classList.add('done')
    this.footer.setAttribute('hidden', '')
    this.footer.style.display = 'none'
    this.step_4_dynamic.innerHTML = ''

    this.fetchStep4(productHandle);  // add this

    setTimeout(() => {
      this.step_3.classList.add('quiz-hide')
      this.step_4.classList.remove('off-right')
      this.next_button.setAttribute('disabled', true)
      this.updateInertStates()
    }, 100);
  }

  goToStep2FromStep3() {
    this.step_3.classList.remove('done')
    this.step_2.classList.remove('off-left')
    this.next_button.dataset.current_step = '2'
    this.step_3.classList.add('off-right')
    this.progress_bar_step_3.classList.remove('done')

    setTimeout(() => {
      this.step_3.classList.add('quiz-hide')
      this.step_2.classList.remove('quiz-hide')
      this.checkStep2NextButton();

      // restore collection total
      const total_el = this.step_2_dynamic.querySelector('[data-collection_total]');
      if (total_el) this.collection_total.textContent = total_el.dataset.collection_total;
      this.updateInertStates()
    }, 100);
  }

  goToStep3FromStep4() {
    this.step_4.classList.remove('done')
    this.step_3.classList.remove('off-left')
    this.next_button.dataset.current_step = '3'
    this.step_4.classList.add('off-right')
    this.progress_bar_step_4.classList.remove('done')
    this.footer.removeAttribute('hidden')
    this.footer.style.display = ''

    setTimeout(() => {
      this.step_4.classList.add('quiz-hide')
      this.step_3.classList.remove('quiz-hide')
      this.next_button.removeAttribute('disabled')
      // re-fetch 3b if empty
      if (!this.step_3b_dynamic.innerHTML.trim()) {
        const checked = this.step_3_dynamic.querySelector('[name="ff_models"]:checked');
        if (checked) this.fetchStep3b(checked.value);
      }
      this.updateInertStates()
    }, 100);
  }


  setOpenerAccessibility() {
    const frameFinderLinks = document.querySelectorAll('.frame-finder-opener, [href="#frame-finder-opener"]');
    if (!frameFinderLinks.length > 0) return;

    frameFinderLinks.forEach( frameFinderLink => {
      frameFinderLink.setAttribute('role', 'button');
      frameFinderLink.setAttribute('aria-haspopup', 'dialog');
      frameFinderLink.addEventListener('click', (event) => {
        event.preventDefault();
        this.resetQuiz();
        this.open(frameFinderLink);
      });
      frameFinderLink.addEventListener('keydown', (event) => {
        if (event.code.toUpperCase() === 'SPACE') {
          event.preventDefault();
          this.resetQuiz();
          this.open(frameFinderLink);
        }
      });
    })

  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    document.getElementById('FrameFinderDrawer').style.display = '';
    setTimeout(() => {
      this.classList.add('active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = document.getElementById('FrameFinderDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  updateInertStates() {
    const current_step = this.next_button.dataset.current_step;
    
    [this.step_1, this.step_2, this.step_3, this.step_4].forEach((step, i) => {
      if (!step) return;
      const step_num = String(i + 1);
      if (step_num === current_step) {
        step.removeAttribute('inert');
      } else {
        step.setAttribute('inert', '');
      }
    });

    // also inert the footer when on step 4 (footer is hidden)
    if (current_step === '4') {
      this.footer.setAttribute('inert', '');
    } else {
      this.footer.removeAttribute('inert');
    }

    this.main.scrollTop = 0;
  }

  resetQuiz() {
    // drawer_inner has visible overflow for dropdown list to expand
    this.drawer_inner.style.overflow = 'visible'
    this.step_1.classList.remove('off-left')
    this.step_1.classList.remove('quiz-hide')
    this.step_2.classList.remove('off-left')
    this.step_3?.classList.remove('off-left')
    this.step_4?.classList.remove('off-left')
    this.step_1.classList.remove('off-right')
    this.step_2.classList.add('off-right')
    this.step_2.classList.add('quiz-hide')
    this.step_3?.classList.add('off-right')
    this.step_3?.classList.add('quiz-hide')
    this.step_4?.classList.add('off-right')
    this.step_4?.classList.add('quiz-hide')
    this.step_2?.setAttribute('inert', '')
    this.step_3?.setAttribute('inert', '')
    this.step_4?.setAttribute('inert', '')
    this.main.removeAttribute('inert')  // add
    this.footer.removeAttribute('inert')

    this.next_button.setAttribute('disabled', true)
    this.next_button.dataset.selected_brand = ''
    this.next_button.dataset.selected_brand_handle = ''
    this.next_button.dataset.current_step = '1'
    this.all_brands_text.textContent = this.all_brands_text.dataset.original_text;
    this.popular_brands.forEach(input => input.checked = false);
    // this.all_brands.forEach(input => input.checked = false);
    this.querySelectorAll('[name="ff_all_brands"]').forEach(input => input.checked = false);

    this.progress_bar.style.display = 'block'
    this.progress_bar_step_2.classList.remove('done')
    this.progress_bar_step_3.classList.remove('done')
    this.progress_bar_step_4.classList.remove('done')
    this.main.style.display = 'block'
    this.footer.style.display = 'block'
    this.quit_wrap.style.display = 'none'
    this.help_wrap.style.display = 'none'
    this.back_text.style.display = 'none'
    this.back_button.classList.remove('is-help')
    this.back_button.style.display = 'none'
    this.close_button.style.display = ''
    this.help_text_brand.removeAttribute('hidden')
    this.help_text_frames.setAttribute('hidden', '')
    this.footer.removeAttribute('hidden')

    const step2_search = this.step_2.querySelector('input[type="search"]');
    if (step2_search) {
      step2_search.value = '';
      delete step2_search.dataset.selectedProductHandle;
      delete step2_search.dataset.selectedProductId;
    }
    const brandDetails = this.querySelector('#ff-facets-filter-brand details');
    if (brandDetails) {
      brandDetails.removeAttribute('open');
      const brandList = brandDetails.querySelector('.radio-select-inputs-brand');
      if (brandList) brandList.scrollTop = 0;
    }

    this.selected_frame_handle = '';
    this.selected_frame_model = '';
    this.selected_model_handle = '';
    this.frame_names.forEach(el => el.textContent = '');
    this.updateInertStates();
    this.step_2_dynamic.innerHTML = '';
    this.step_3_dynamic.innerHTML = '';
    this.step_3b_dynamic.innerHTML = '';
    this.step_4_dynamic.innerHTML = '';
    
    this.main.scrollTop = 0;
  }
  
  checkStep2NextButton() {
    const search_input = this.step_2.querySelector('[data-selected-product-handle]');
    if (search_input?.dataset.selectedProductHandle) {
      this.next_button.removeAttribute('disabled');
    } else {
      this.next_button.setAttribute('disabled', true);
    }
  }

  maybeClose() {
    if (this.back_button.classList.contains('is-help')) {
      this.close();
      this.resetQuiz();
      return;
    }
    if (this.next_button.dataset.selected_brand === '') {
      this.drawer_inner.style.opacity = 0;
      this.close();
      setTimeout(() => {
        this.resetQuiz();
        this.drawer_inner.style.opacity = 1;
      }, 400);
      return;
    }
    this.progress_bar.style.display = 'none'
    this.main.style.display = 'none'
    this.footer.style.display = 'none'
    this.back_text.style.display = 'none'
    this.main.setAttribute('inert', '')
    this.quit_wrap.style.display = 'block'
    this.close_button.style.display = 'none'
    this.back_button.style.display = 'none'
  }

  resumeQuiz() {
    this.progress_bar.style.display = 'block'
    this.main.style.display = 'block'
    this.main.removeAttribute('inert')  // add
    this.footer.removeAttribute('inert')
    this.footer.style.display = 'block'
    this.quit_wrap.style.display = 'none'
    this.close_button.style.display = ''
    this.back_button.style.display = this.next_button.dataset.current_step === '1' ? 'none' : 'flex'
  }

  showHelp() {
    this.progress_bar.style.display = 'none'
    this.main.style.display = 'none'
    this.main.setAttribute('inert', '')
    this.footer.setAttribute('inert', '')
    this.footer.style.display = 'none'
    this.help_wrap.style.display = 'block'
    this.back_button.style.display = 'flex'
    this.back_button.classList.add('is-help')
    this.back_text.style.display = 'block'
    this.main_title.classList.add('cloak-me-mobile')
  }

  hideHelp() {
    this.progress_bar.style.display = 'block'
    this.main.style.display = 'block'
    this.main.removeAttribute('inert')
    this.help_wrap.style.display = 'none'

    // only restore footer if not on step 4
    if (this.next_button.dataset.current_step !== '4') {
      this.footer.removeAttribute('inert')
      this.footer.style.display = 'block'
    }

    this.back_button.classList.remove('is-help')
    this.back_text.style.display = 'none'
    if (this.next_button.dataset.current_step === '1') {
      this.back_button.style.display = 'none'
    }
    this.main_title.classList.remove('cloak-me-mobile')
    if (this.next_button.dataset.current_step === '2') {
      this.checkStep2NextButton();
    }
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
    document.getElementById('FrameFinderDrawer').style.display = 'none';
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  fetchBrands() {
    const section_id = 'frame-finder-brands';
    let brands = [];
    let paginate;

    const load = async (page) => {
      const url = `/collections/replacement-lenses?section_id=${section_id}&page=${page}`;
      const res = await fetch(url).then(r => r.text());
      const html = new DOMParser().parseFromString(res, 'text/html');
      const el = html.querySelector('[data-brand-names]');
      if (!el) return;

      const names = JSON.parse(el.dataset.brandNames);
      const handles = JSON.parse(el.dataset.brandHandles);
      const page_brands = names
        .map((name, i) => ({ 
          name, 
          handle: handles[i].toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') + '-replacement-lenses'
        }))
        .filter(b => !/^any/i.test(b.name.trim()));

      const seen = new Set(brands.map(b => b.handle));
      page_brands.forEach(b => {
        if (!seen.has(b.handle)) { seen.add(b.handle); brands.push(b); }
      });
      brands.sort((a, b) => a.name.localeCompare(b.name));

      const page_data = html.querySelector('[data-paginate]');  // ✅ re-added
      if (!paginate && page_data) {
        paginate = JSON.parse(page_data.dataset.paginate);
      }

      if (!paginate || page >= paginate.pages) {
        this.buildBrandList(brands);
      }
    }

    load(1).then(() => {
      if (!paginate || paginate.pages <= 1) return;
      const pages = [];
      for (let n = 2; n <= paginate.pages; n++) {
        pages.push(load(n));
      }
      Promise.all(pages).then(() => this.buildBrandList(brands));
    });
  }

  // In buildBrandList, change the brands array to expect objects: { name, handle }
// Then the radio value and data-brand are both read from source data, not re-derived.

buildBrandList(brands) {
  const container = this.querySelector('.ff-brand-radio-list');
  if (!container) return;

  const grouped = brands.reduce((acc, brand) => {
    const letter = brand.name.charAt(0).toUpperCase();
    if (!acc[letter]) acc[letter] = [];
    acc[letter].push(brand);
    return acc;
  }, {});

  const sorted_keys = Object.keys(grouped).sort();
  container.innerHTML = '';

  sorted_keys.forEach(letter => {
    const group_div = document.createElement('div');
    const h3 = document.createElement('h3');
    h3.textContent = letter;
    group_div.appendChild(h3);

    grouped[letter].forEach(({ name, handle }) => {
      const id = `ff-all-brands-${handle}`;
      const item = document.createElement('div');
      item.className = 'sort-item';
      item.innerHTML = `
        <input type="radio" name="ff_all_brands" id="${id}" value="${handle}" class="visually-hidden" data-brand="${name}"  tabindex="0">
        <label class="active-facets__button active-facets__button--light" for="${id}">
          ${name}
        </label>
      `;
      group_div.appendChild(item);
    });

    container.appendChild(group_div);
  });

  this.all_brands = this.querySelectorAll('[name="ff_all_brands"]');
}

retrapFocus() {
  const containerToTrapFocusOn = document.getElementById('FrameFinderDrawer');
  const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
  trapFocus(containerToTrapFocusOn, focusElement);
}

}

customElements.define('frame-finder-drawer', FrameFinderDrawer);

/* class CartDrawerItems extends CartItems {

}
customElements.define('cart-drawer-items', FrameFinderDrawer);
 */

// Replace the global debug listener with this permanent fix:
document.addEventListener('keydown', (evt) => {
  if (evt.key !== 'Enter') return;
  
  // Only act if the frame finder drawer is open
  if (!document.querySelector('frame-finder-drawer.active')) return;
  
  const drawer = document.querySelector('frame-finder-drawer');
  if (!drawer) return;
  
  // Don't fire if focus is in a legacy search input
  if (document.activeElement.matches?.('input[type="search"]') && document.activeElement.closest?.('.frame-search-wrap-3')) {
    evt.preventDefault();
    drawer.handleLegacySearch(document.activeElement);
    return;
  }
  
  // Prevent form submission if focused in any search input
  if (document.activeElement.type === 'search') {
    evt.preventDefault();
  }
  
  if (document.activeElement.tagName === 'TEXTAREA') return;
  
  if (!drawer.next_button.hasAttribute('disabled')) {
    evt.preventDefault();
    drawer.handleNext();
  }
});